import { ReactNode } from "react";

interface MainContentProps {
  children: ReactNode;
  className?: string;
  id?: string;
}

/**
 * MainContent wrapper component for accessibility
 * Wraps the main content of each page with proper landmarks
 * Use this as the direct child of your page layouts
 */
export function MainContent({ 
  children, 
  className = "",
  id = "main-content"
}: MainContentProps) {
  return (
    <main 
      id={id}
      className={className}
      role="main"
      tabIndex={-1} // Allows programmatic focus but not tab focus
    >
      {children}
    </main>
  );
}

export default MainContent;
